import Music from '../../assets/icons/audioplayer/music.svg';
import { Track, useAudioPlayerContext } from './context/AudioPlayerContext';

export const PlayList = () => {
  const { currentTrack, tracks, setIsPlaying, setCurrentTrack } = useAudioPlayerContext();

  const handleClick = (track: Track) => {
    setCurrentTrack(track);
    setIsPlaying(true);
  };

  return (
    <ul className="bg-secondary-700 text-white overflow-y-auto">
      {tracks.map((track, index) => (
        <li
          key={index}
          className={`flex items-center gap-3 md:px-4 py-4 cursor-pointer transition-colors duration-200 ${currentTrack.id === track.id ? 'bg-secondary-700' : 'hover:bg-secondary-500'
            }`}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleClick(track);
            }
          }}
          onClick={() => handleClick(track)}
        >
          <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-sm overflow-hidden">
            <img src={currentTrack?.thumbnail || Music} srcSet={`${currentTrack?.thumbnail || Music} 1x, ${currentTrack?.thumbnail || Music} 2x`} loading="lazy" alt="audio avatar" className="w-full h-full object-cover bg-gray-300 rounded-sm sm:rounded-full" />
          </div>
          <div>
            <p className={`font-bold text-sm line-clamp-1 ${currentTrack.id === track.id ? 'text-primary-700':'' }`}>{track?.title}</p>
            <p className="text-sm text-[#6C6C6C] line-clamp-1" dangerouslySetInnerHTML={{ __html: track?.description }}></p>
          </div>
        </li>
      ))}
    </ul>
  );
};